module.exports = __webpack_public_path__ + "img/feature-1@2x.1a4d76bd.jpg";